import React from 'react';

import {OECheckEnvResultType, OEStatusType} from '../../react-oe/oe-surface';
import OEBrowserBar from '../elements/oe-browser-bar'

export default class OEStatusDlgHandler {

    constructor(modalContainer) {
        this.modalContainer = modalContainer;
    }

    onStatusChanged(status, modalContainer) {

        while(status.type === OEStatusType.aborted || status.type === OEStatusType.envWarning)   {
            let checkEnvResult = status.userInfo.checkEnvResult;
            if(checkEnvResult.type === OECheckEnvResultType.ok) break;

            let modContainer = modalContainer || this.modalContainer;
            if(modContainer == null)    {
                console.log('Problem detected with no modal container in place. ' + checkEnvResult.msg);
                break;
            }

            let content = function()    {
                let showBrowserBar = checkEnvResult.showBrowserBar;

                // for some unknown reason react treats some parts of the content of <div className="status-dlg"> as an array and warns of missing keys
                // the only way to get rid of this is to assign some virtual needless keys

                return (
                    <div className="status-dlg">
                        <span key="0" className="message">{checkEnvResult.msg}</span>

                        {!showBrowserBar && !checkEnvResult.msg2 ? null : (
                            <div key="1">
                                <span key="2" className="upgrade-message">{checkEnvResult.msg2 ? checkEnvResult.msg2 : 'Please upgrade your browser and launch the app again or use one of the following browser:'}</span>
                                {showBrowserBar ? <OEBrowserBar key="3" className="upgrade-browser-bar"/> : null}
                            </div>
                        )}
                    </div>
                );
            };

            let zIndex = 1101; // over other modals (1050) & over theme indicator view (1100)
            modContainer.addModal('Problem detected!', content, (id, container) => [], {zIndex: zIndex, hasCloseBtn: !checkEnvResult.fatal});

            break;
        }
    }
};